"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@remirror/react");
const core_extensions_1 = require("@remirror/core-extensions");
const extension_image_1 = require("@remirror/extension-image");
// import { ProsemirrorDevTools } from '@remirror/dev';
const core_1 = require("@remirror/core");
const react_use_1 = require("react-use");
exports.OsmosysRichEditorInner = (_a) => {
    var { onChange, value } = _a, props = tslib_1.__rest(_a, ["onChange", "value"]);
    const [hasFocus, setHasFocus] = react_use_1.useToggle(false);
    return (react_1.default.createElement(react_2.RemirrorManager, { useBaseExtensions: true },
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.PlaceholderExtension, placeholderStyle: {
                color: '#aaa',
                fontStyle: 'normal',
                fontWeight: 300,
                letterSpacing: '0.5px',
                position: 'absolute',
            }, placeholder: "placeholder" }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.ParagraphExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.DropCursorExtension, priority: 1 }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.BoldExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.UnderlineExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.ItalicExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.BlockquoteExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.StrikeExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.CodeExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.HeadingExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.HorizontalRuleExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: extension_image_1.ImageExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.ListItemExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.BulletListExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.OrderedListExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.HardBreakExtension }),
        react_1.default.createElement(react_2.RemirrorExtension, { Constructor: core_extensions_1.TrailingNodeExtension }),
        react_1.default.createElement(react_2.ManagedRemirrorProvider, Object.assign({ initialContent: value || '', stringHandler: core_1.fromHTML }, props, { childAsRoot: false, onChange: ({ getHTML }) => {
                onChange(getHTML());
            }, onBlur: () => {
                if (hasFocus) {
                    setHasFocus(false);
                }
            }, onFocus: () => {
                if (!hasFocus) {
                    setHasFocus(true);
                }
            } }),
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Editor, { value: value, hasFocus: hasFocus })))));
};
const Editor = ({ value, hasFocus }) => {
    const { getRootProps, setContent } = react_2.useRemirrorContext();
    react_1.useEffect(() => {
        if (!hasFocus) {
            setContent(value, true);
        }
    }, [value, hasFocus]);
    return (react_1.default.createElement("div", Object.assign({ className: "d-flex flex-col flex-grow-1" }, getRootProps(), { css: null })));
};
//# sourceMappingURL=Inner.js.map